<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-doc"></i>
                            <span>{{$t('survey_template.title')}}</span>
                        </h2>
                        <div @click.prevent="editTemplateDetails" class="panel_header__action">
                            <i class="panel_header__action__icon icons icon-pencil"></i>
                            <a class="button--link">{{$t('survey_template.edit')}}</a>
                        </div>
                    </div>
                    <div class="panel__body">
                        <template>
                            <h1>{{template.title}}</h1>
                            <h2>
                                {{ $t('survey_template.type')}}:
                                {{ $t('forms.survey_template.types.' + template.type)}}
                            </h2>
                            <br/>

                            <div class="panel__list">
                                <div class="panel__list__item first">
                                    <a class="button--cta inline-block pull-right" @click="addQuestion()">{{$t('survey_template.add_question')}}</a>
                                </div>
                                <div class="panel__list__item--bg" v-for="(question, index) in questions" :key="question.id">
                                    <h3>{{question.description}} {{question.required ? '*' : ''}}</h3>
                                    <component :is="`survey-question-${question.type.value ? question.type.value : question.type }-form`" v-model="questions[index]" :locked="true" />

                                    <div class="panel__list__item__actions">
                                        <span class="panel__list__item__action" v-if="!$store.getters.isFirstQuestion(question)" @click="moveQuestionUp(question)">
                                            <i class="icons icon-arrow-up"></i>
                                            <a class="button--link">{{$t('survey_template.move_up')}}</a>
                                        </span>
                                        <span class="panel__list__item__action" v-if="!$store.getters.isLastQuestion(question)" @click="moveQuestionDown(question)">
                                            <i class="icons icon-arrow-down"></i>
                                            <a class="button--link">{{$t('survey_template.move_down')}}</a>
                                        </span>
                                        <span class="panel__list__item__action" @click="editQuestion(question)">
                                            <i class="icons icon-pencil"></i>
                                            <a class="button--link">{{$t('common.edit')}}</a>
                                        </span>
                                        <span class="panel__list__item__action" @click="deleteQuestion(question)">
                                            <i class="icons icon-trash"></i>
                                            <a class="button--link">{{$t('common.delete')}}</a>
                                        </span>
                                    </div>
                                </div>

                                <div class="panel__list__item last">
                                    <a @click="addQuestion()" class="button--cta inline-block pull-right">{{$t('survey_template.add_question')}}</a>
                                </div>
                            </div>
                        </template>
                    </div>
                    <survey-template-modal />
                    <survey-template-question-modal />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    import SurveyTemplateModal from '@/components/modals/survey-templates/SurveyTemplateModal';
    import SurveyTemplateQuestionModal from '@/components/modals/survey-templates/SurveyTemplateQuestionModal';

    import SurveyQuestionLikertForm from '@/components/forms/survey/SurveyQuestionLikertForm';
    import SurveyQuestionMultipleForm from '@/components/forms/survey/SurveyQuestionMultipleForm';
    import SurveyQuestionOpenForm from '@/components/forms/survey/SurveyQuestionOpenForm';
    import SurveyQuestionScaleForm from '@/components/forms/survey/SurveyQuestionScaleForm';

    import {
        GET_SURVEY_TEMPLATE,
        SAVE_SURVEY_TEMPLATE,
        DELETE_SURVEY_TEMPLATE_QUESTION,
        MOVE_QUESTION_UP,
        MOVE_QUESTION_DOWN
    } from '@/store/modules/survey-template';

    @Component({
        components: {
            SurveyTemplateModal,
            SurveyTemplateQuestionModal,
            SurveyQuestionLikertForm,
            SurveyQuestionMultipleForm,
            SurveyQuestionOpenForm,
            SurveyQuestionScaleForm,
        }
    })
    export default class SurveyTemplate extends Vue {
        name = 'survey-template';

        created() {
            const id = +this.$route.params.id;
            this.$store.dispatch(GET_SURVEY_TEMPLATE, { id })
                .catch(
                    err => {
                        if (err.status === 404) {
                            this.$notify.error(this.$t('notify.template.not_found', { id }));
                            this.$router.replace({name: 'page_not_found'});
                        }
                    });
        }

        get loading() {
            return this.$store.state.survey_template.loading;
        }

        get template() {
            return this.$store.state.survey_template.template;
        }

        get questions() {
            return this.$store.state.survey_template.template.questions;
        }

        editTemplateDetails() {
            this.$modal.show('survey-template-modal', { template: this.template });
        }

        addQuestion() {
            this.$modal.show('survey-template-question-modal', { question: {} });
        }

        moveQuestionUp(question) {
            return this.$store.commit(MOVE_QUESTION_UP, { question });
        }

        moveQuestionDown(question) {
            return this.$store.commit(MOVE_QUESTION_DOWN, { question });
        }

        editQuestion(question) {
            this.$modal.show('survey-template-question-modal', { question });
        }

        deleteQuestion(question) {
            this.$store.dispatch(DELETE_SURVEY_TEMPLATE_QUESTION, { question })
                .then(() => {
                    this.$notify.success(this.$t('notify.survey_template_question.delete_success'));
                })
                .catch(err => {
                    this.$store.dispatch(GET_SURVEY_TEMPLATE, {});
                    let errorMsg = err.status === 404 && err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.survey_template_question.delete_error');
                    this.$notify.error(errorMsg);
                });
        }

        save() {
            this.$store.dispatch(SAVE_SURVEY_TEMPLATE, { })
                .then(res => this.$router.push({name: 'survey-templates'}));
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/SurveyTemplate.vue